import React, { useState } from "react";

interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabMenuProps {
  tabs: Tab[];
}

const TabMenu: React.FC<TabMenuProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="main-tabs-section">
      <ul className="nav menu-nav">
        {tabs.map((tab, index) => (
          <li className="nav-item" key={index}>
            <span
              className={`nav-link ${activeTab === index && "active"}`}
              onClick={() => setActiveTab(index)}
            >
              {tab.label}
            </span>
          </li>
        ))}
      </ul>
      <div className="tab-content">{tabs[activeTab].content}</div>
    </div>
  );
};

export default TabMenu;
